import React from 'react';
import { graphql } from 'react-relay';
import { Query } from '../../index';
import { populateChildren } from '../toolbox';

export const QTagsQuery = graphql`
  query QTagsQuery($scope: DocumentScopeEnum!, $offerId: ID, $itemType: String, $isAnalytics: Boolean) {
    tags(scope: $scope, offerId: $offerId, itemType: $itemType, isAnalytics: $isAnalytics) {
      id
      name
      itemType
      itemsIds
      color
      isDefault
      dates {
        creation
        lastUpdate
      }
    }
  }
`;

const QTags = ({
  children,
  childDataProp,
  args,
  fetchPolicy
}) => (
  <Query
    query={QTagsQuery}
    args={args}
    fetchPolicy={fetchPolicy}
  >
    {populateChildren('tags')(children, childDataProp)}
  </Query>
);

export default QTags;
